import errorBoundary from '@ifeng/errorBoundary';
import React from 'react';
import { Base64 } from './base64';
import { Base62 } from './base62';
import Pc from './pc';
import Mobile from './mobile';
import ajax from '../../common/ajax';

// webpack.config.js文件 remUnit修改为19.5

class Layout extends React.PureComponent {
    state = {
        isMobile: false,
        isPC: false,
        qrcodeUrl: '',
        schemeUrl: '',
        webUrl: '',
    };

    getQueryVariable = (variable, urlParam) => {
        const query = urlParam || window.location.search.substring(1);
        const vars = query.split('&');

        for (let i = 0; i < vars.length; i++) {
            const pair = vars[i].split('=');

            if (pair[0] === variable) {
                return pair[1];
            }
        }

        return '';
    };

    name = this.getQueryVariable('name') || 'ifengVane';
    path = (this.getQueryVariable('path') && decodeURIComponent(this.getQueryVariable('path'))) || 'pages/index/index';
    param = (this.getQueryVariable('param') && decodeURIComponent(this.getQueryVariable('param'))) || '';

    componentDidMount() {
        this.clientHanle();
    }

    getSchemeURL = async () => {
        const uiqueStr = this.getUiqueStr();
        const pathStr = this.path;
        const pathParam = this.param;
        const pathParamItem = pathParam.split('&');
        const pathBase64 = Base64.encode(pathStr);
        const appletName = this.name;

        const pathParamObj = {};

        pathParamItem.forEach(item => {
            if (item) {
                const key = item.split('=')[0];
                const value = item.split('=')[1];

                pathParamObj[key] = value;
            }
        });

        console.log(pathParamObj, '222222222222');

        const result = await ajax(
            `https://shankapi.ifeng.com/keystone/scheme/getScheme/${appletName}/${uiqueStr}/${pathBase64}/0/0/0/0`,
        );

        if (result && result.code === 0 && result.data) {
            this.setState({
                schemeUrl: result.data,
            });
        } else {
            // 默认小程序首页
            this.setState({
                schemeUrl: 'weixin://dl/business/?t=uuxuicTAqQa',
            });
        }

        this.saveQrcodeKey(uiqueStr, pathParamObj);
    };

    clientHanle = () => {
        const userAgent = navigator.userAgent.toLocaleLowerCase();

        if (userAgent.includes('mobile')) {
            this.setState(
                {
                    isMobile: true,
                },
                () => {
                    this.getSchemeURL();
                },
            );
        } else {
            this.setState(
                {
                    isPC: true,
                },
                () => {
                    this.getQRcodeURL();
                },
            );
        }
    };

    getUserkey = l => {
        const len = l || 32;
        const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz0123456789';
        const charsLen = chars.length;
        let uid = '';

        for (let i = 0; i < len; i++) {
            uid += chars.charAt(Math.floor(Math.random() * charsLen));
        }

        return uid;
    };

    getUiqueStr = () => {
        const unionId = Math.ceil(Math.random() * 1000000);
        const uiqueStr = Base62.encode(unionId) + new Date().getTime() + this.getUserkey(10);

        return uiqueStr;
    };

    saveQrcodeKey = async (uiqueStr, params = {}) => {
        let selfParam = '';

        for (const key in params) {
            selfParam += `${key}=${params[key]}&`;
        }
        const paramsStr = selfParam.substr(0, selfParam.length - 1);

        const result = await ajax('https://shankapi.ifeng.com/keystone/kv/saveDataToKV', {
            data: {
                key: uiqueStr,
                value: paramsStr,
            },
            cache: false,
        });

        return result;
    };

    getQRcodeURL = () => {
        const uiqueStr = this.getUiqueStr();
        const pathStr = this.path;
        const pathParam = this.param;
        const pathParamItem = pathParam.split('&');
        const pathBase64 = Base64.encode(pathStr);
        const appletName = this.name;
        const qrcodeUrl = `https://shankapi.ifeng.com/keystone/qrcode/getWxaQRCode/${uiqueStr}/${pathBase64}/${appletName}/120/0/0/255/255/255`;
        const pathParamObj = {};

        pathParamItem.forEach(item => {
            if (item) {
                const key = item.split('=')[0];
                const value = item.split('=')[1];

                pathParamObj[key] = value;
            }
        });

        this.setState({
            qrcodeUrl,
        });

        this.saveQrcodeKey(uiqueStr, pathParamObj);
    };

    render() {
        const { isMobile, isPC, qrcodeUrl, schemeUrl } = this.state;
        const webUrl = `https://ifengzhishu.ifeng.com?immersion=true&online=1`;

        return (
            <>
                {isPC && qrcodeUrl && <Pc qrcodeUrl={qrcodeUrl} />}
                {isMobile && schemeUrl && <Mobile schemeUrl={schemeUrl} webUrl={webUrl} />}
            </>
        );
    }
}

export default errorBoundary(Layout);
